import { of, concat } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { flatMap, map, catchError } from 'rxjs/operators';
import { Epic, ofType } from 'redux-observable';
import { getPostOptionsObject, getOptionsObject } from '../../utils/api';
import {
  FETCH_SIMULATION_CURRENT_WANT,
  fetchSimulationCurrentWantSuccess,
  fetchSimulationCurrentWantError,
  FETCH_SIMULATION_CURRENT_HAVE,
  fetchSimulationCurrentHaveSuccess,
  fetchSimulationCurrentHaveError,
  POST_SIMULATION,
} from './actions';
import { fetchRIScenarioError, updateRIScenario } from '../ri-scenario/actions';

export const fetchRetirementIncome: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_SIMULATION_CURRENT_WANT),
    flatMap(() =>
      ajax(
        getPostOptionsObject(
          '/retirement-income-ui/service/ri-simulation?simulationType=CURRENT_WANT&refreshFromMStar=true',
        ),
      )
        .pipe(map((res: any) => fetchSimulationCurrentWantSuccess(res.response)))
        .pipe(catchError(ex => of(fetchSimulationCurrentWantError(ex)))),
    ),
  );

export const fetchSavingsBalance: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_SIMULATION_CURRENT_HAVE),
    flatMap(action =>
      ajax(
        getPostOptionsObject(
          `/retirement-income-ui/service/ri-simulation?simulationType=CURRENT_HAVE&refreshFromMStar=false&mStarReqId=${action.payload}`,
        ),
      )
        .pipe(map((res: any) => fetchSimulationCurrentHaveSuccess(res.response)))
        .pipe(catchError(ex => of(fetchSimulationCurrentHaveError(ex)))),
    ),
  );

export const postSimulation: Epic = action$ =>
  action$.pipe(
    ofType(POST_SIMULATION),
    flatMap(action =>
      concat(
        ajax(
          getPostOptionsObject(
            '/retirement-income-ui/service/ri-simulation?simulationType=CURRENT_WANT&refreshFromMStar=true',
            action.payload,
          ),
        )
          .pipe(map((res: any) => fetchSimulationCurrentWantSuccess(res.response)))
          .pipe(catchError(ex => of(fetchSimulationCurrentWantError(ex)))),
        ajax(getOptionsObject('/retirement-income-ui/service/ri-scenario'))
          .pipe(map((res: any) => updateRIScenario(res.response)))
          .pipe(catchError(ex => of(fetchRIScenarioError(ex)))),
      ),
    ),
  );
